import {
    getQnaList,
    getQna,
    createQna,
    cancelQna,
    updateQna,
} from "../apis/api_qna.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, userId: 0},
    items: [],
    item: {},
    
    itemWrite: {
        id:'',
        userId:'',
        adminId:'',
        title:'',
        content:'',
        answer:'',
        type:'',
    }
};

const getters = {
};

const mutations = {
    SET_QNA_LIST(state, items){
        state.items = items;
    },

    SET_QNA(state, payload) {
        state.item = payload
    },

    CLEAR_QNA(state) {
        state.item = {};
    },

    SET_QNA_WRITE(state, qna) {
        state.itemWrite = qna;
    },
};

const actions = {

    async GET_QNA_LIST({ state, commit }, params = {}) {
        let filters = { ...state.filters,...params };
        console.log(filters);
        try {
            const response = await getQnaList(filters);
            commit('SET_QNA_LIST', response.data.data.content)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_QNA({ commit }, id) {
        try {
            const response = await getQna(id);
            commit('SET_QNA', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CREATE_QNA(context, qna) {
        try {
            const response = await createQna(qna);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CANCEL_QNA(context, id) {
        try {
            const response = await cancelQna(id);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async UPDATE_BOARD(context, qna) {
        try {
            const response = await updateQna(qna);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
            
        }
    },
};

export default {mutations, state, actions, getters};